module.exports = __webpack_public_path__ + "mail.svg?b76b6784fa09967fdeff2f2a6737b137";